import { lazy, Suspense } from 'react';
import { BrowserRouter, HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useRoomPresenceTracker } from './lib/roomPresence';
import { HubPage } from './pages/HubPage';
import { LoginPage } from './pages/LoginPage';
import { UpdateNotice } from './components/App/UpdateNotice';
import { AdConsent } from './components/App/AdConsent';

// Rutas con escena 3D: se cargan bajo demanda para aligerar el arranque.
const LobbyPage = lazy(() => import('./pages/LobbyPage').then((m) => ({ default: m.LobbyPage })));
const MatchPage = lazy(() => import('./pages/MatchPage').then((m) => ({ default: m.MatchPage })));
const ResetPasswordPage = lazy(() =>
  import('./pages/ResetPasswordPage').then((m) => ({ default: m.ResetPasswordPage }))
);
const HowToPlayPage = lazy(() => import('./pages/HowToPlayPage').then((m) => ({ default: m.HowToPlayPage })));
const PrivacyPage = lazy(() => import('./pages/LegalPage').then((m) => ({ default: m.PrivacyPage })));
const TermsPage = lazy(() => import('./pages/LegalPage').then((m) => ({ default: m.TermsPage })));
const StadiumPage = lazy(() => import('./pages/StadiumPage').then((m) => ({ default: m.StadiumPage })));

const RouteFallback = () => (
  <div className="grid min-h-screen place-items-center bg-ink-900 text-sm text-slate-400">Cargando…</div>
);

/**
 * Enrutador principal del cliente.
 * Rutas:
 *   /                → Hub / Catálogo
 *   /lobby/:roomId   → Lobby de Espera
 *   /match/:roomId   → Partido en vivo (3D + HUD + controles)
 *   /login           → Login / Registro / Recuperar contraseña
 *   /reset           → Nueva contraseña (enlace del correo)
 *   /stadium         → Vista 3D pública del estadio (sin auth requerida)
 *   /privacidad      → Política de privacidad (texto base)
 *   /terminos        → Términos de uso (texto base)
 */
/** Libera la plaza en una sala cuando la URL sale de ella. */
const RoomPresence = () => {
  useRoomPresenceTracker();
  return null;
};

/** Portales (CrazyGames, Poki, itch.io): rutas tras # (el servidor del portal no conoce /lobby/…). */
const Router = import.meta.env.VITE_ROUTER === 'hash' ? HashRouter : BrowserRouter;

const App = () => (
  <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <RoomPresence />
    <UpdateNotice />
    <AdConsent />
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<HubPage />} />
        <Route path="/lobby/:roomId" element={<LobbyPage />} />
        <Route path="/match/:roomId" element={<MatchPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset" element={<ResetPasswordPage />} />
        <Route path="/como-se-juega" element={<HowToPlayPage />} />
        <Route path="/stadium" element={<StadiumPage />} />
        <Route path="/privacidad" element={<PrivacyPage />} />
        <Route path="/terminos" element={<TermsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  </Router>
);

export default App;
